import { connect } from 'react-redux';
import { localizationSelectors } from '@lifesize/nucleus';
import CalendarDay from 'components/CalendarDay/CalendarDay';
import { getStartTime, getEndTime, startOfDay, endOfDay } from 'utils/calendar-utils';
import { ONE_DAY } from 'constants/Calendar';
import calendarSelectors from 'selectors/calendar';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => {
  const today = new Date();
  const targetDay = new Date();
  // set the targetDay to an integer number of days (ownProps.day) from now. targetDay remains a date (object)
  targetDay.setDate(today.getDate() + ownProps.day);

  const dayFormatOptions = {
    weekday: 'long'
  };

  const dateFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  };

  const languageId = _get(localizationSelectors.localization(state), 'languageId'); // BCP 47 language tag
  const dayName = targetDay.toLocaleDateString(languageId, dayFormatOptions);
  const longDate = targetDay.toLocaleDateString(languageId, dateFormatOptions);

  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const twoDays = ONE_DAY * 2;
  const timeDifference = targetDay.getTime() - today.getTime();

  const isToday = timeDifference < ONE_DAY;
  const isTomorrow = timeDifference >= ONE_DAY && timeDifference < twoDays;

  const startOfTargetDay = startOfDay(targetDay);
  const endOfTargetDay = endOfDay(targetDay);
  const allEvents = calendarSelectors.lifesizeMeetingsSelector(state);

  const events = allEvents.filter((event) => {
    const startTime = new Date(getStartTime(event));
    const endTimeRaw = getEndTime(event);

    if (endTimeRaw) {
      const endTime = new Date(endTimeRaw);
      return (startTime >= startOfTargetDay && startTime < endOfTargetDay) ||
        (endTime && (startTime < startOfTargetDay && endTime > startOfTargetDay));
    }

    return (startTime >= startOfTargetDay && startTime < endOfTargetDay);
  });

  return {
    isToday,
    isTomorrow,
    targetDay,
    dayName,
    longDate,
    events
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDay);
